// Hand-drawn line-art SVG illustrations, ported from the Hi-Fi prototype.
// All are decorative and marked aria-hidden.

const INK = '#0E0E0E';
const INK_FAINT = '#9A9AA2';
const GOLD = '#FF6464';
const GOLD_SOFT = '#FFCFCC';
const PAPER = '#FFFFFF';

// ============== Per-step illustrations ==============

export function BookIllustration({className = 'w-[130px] h-[110px]'}) {
    return (
        <svg viewBox="0 0 130 110" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 25 L10 88 Q10 92 14 92 L60 92 L60 32 Q60 22 50 22 L14 22 Q10 22 10 25 Z" fill={PAPER}/>
                <path d="M60 32 Q60 22 70 22 L106 22 Q110 22 110 25 L110 88 Q110 92 106 92 L60 92 Z" fill={PAPER}/>
                <path d="M60 32 L60 92" strokeDasharray="2 3"/>
                <path d="M20 40 L50 40 M20 50 L45 50 M20 60 L48 60" stroke={INK_FAINT} strokeWidth="1"/>
                <path d="M70 40 L100 40 M70 50 L95 50 M70 60 L98 60" stroke={INK_FAINT} strokeWidth="1"/>
                <circle cx="85" cy="75" r="4" fill={GOLD} stroke="none"/>
                <path d="M83 75 L85 77 L88 73" stroke={PAPER} strokeWidth="1.3"/>
            </g>
        </svg>
    );
}

export function HeartIllustration({className = 'w-[120px] h-[100px]'}) {
    return (
        <svg viewBox="0 0 120 100" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M60 85 L22 48 Q12 38 20 26 Q30 14 42 22 L60 38 L78 22 Q90 14 100 26 Q108 38 98 48 Z"
                      fill={GOLD_SOFT}/>
                <path d="M30 20 L26 14 M30 14 L26 20" stroke={GOLD}/>
                <circle cx="95" cy="18" r="2" fill={GOLD} stroke="none"/>
                <path d="M50 50 Q60 58 70 50" stroke={INK} strokeWidth="1"/>
            </g>
        </svg>
    );
}

export function CakeIllustration({className = 'w-[110px] h-[110px]'}) {
    return (
        <svg viewBox="0 0 110 110" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 70 Q20 58 32 58 L78 58 Q90 58 90 70 L90 92 L20 92 Z" fill={GOLD_SOFT}/>
                <path d="M20 78 Q35 74 55 78 T90 78" fill="none"/>
                <line x1="55" y1="58" x2="55" y2="34"/>
                <path d="M50 34 Q55 22 60 34" fill={GOLD} stroke="none"/>
                <circle cx="55" cy="24" r="3" fill={GOLD}/>
            </g>
        </svg>
    );
}

export function StarIllustration({className = 'w-[130px] h-[130px]'}) {
    return (
        <svg viewBox="0 0 130 130" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round">
                <circle cx="65" cy="65" r="48" strokeDasharray="3 5"/>
                <path d="M65 30 L71 55 L97 58 L77 75 L84 100 L65 86 L46 100 L53 75 L33 58 L59 55 Z" fill={GOLD_SOFT}/>
                <circle cx="25" cy="30" r="2" fill={GOLD} stroke="none"/>
                <circle cx="108" cy="45" r="1.5" fill={GOLD} stroke="none"/>
                <circle cx="20" cy="95" r="1.5" fill={GOLD} stroke="none"/>
                <circle cx="110" cy="100" r="2" fill={GOLD} stroke="none"/>
            </g>
        </svg>
    );
}

export function CompassIllustration({className = 'w-[130px] h-[130px]'}) {
    return (
        <svg viewBox="0 0 130 130" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round">
                <circle cx="65" cy="65" r="50" fill={PAPER}/>
                <circle cx="65" cy="65" r="42" strokeDasharray="2 4" stroke={INK_FAINT}/>
                <path d="M65 30 L72 65 L65 72 L58 65 Z" fill={GOLD} stroke={INK}/>
                <path d="M65 100 L72 65 L65 58 L58 65 Z" fill={PAPER} stroke={INK}/>
                <circle cx="65" cy="65" r="3" fill={INK}/>
                <text x="65" y="22" textAnchor="middle" fontSize="10" fontFamily="Inter" fontWeight="700"
                      fontStyle="italic" fill={INK}>С
                </text>
                <text x="65" y="118" textAnchor="middle" fontSize="10" fontFamily="Inter" fontWeight="700"
                      fontStyle="italic" fill={INK}>Ю
                </text>
            </g>
        </svg>
    );
}

export function MicIllustration({className = 'w-[100px] h-[130px]'}) {
    return (
        <svg viewBox="0 0 100 130" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round">
                <rect x="38" y="20" width="24" height="50" rx="12" fill={GOLD_SOFT}/>
                <path d="M25 60 Q25 85 50 85 Q75 85 75 60" fill="none"/>
                <line x1="50" y1="85" x2="50" y2="105"/>
                <line x1="35" y1="105" x2="65" y2="105"/>
                <path d="M15 45 Q8 50 15 60" stroke={GOLD}/>
                <path d="M85 45 Q92 50 85 60" stroke={GOLD}/>
                <path d="M8 40 Q0 55 8 68" stroke={GOLD} strokeDasharray="2 3"/>
                <path d="M92 40 Q100 55 92 68" stroke={GOLD} strokeDasharray="2 3"/>
            </g>
        </svg>
    );
}

export function ClosedBookIllustration({className = 'w-32 h-32'}) {
    return (
        <svg viewBox="0 0 160 160" className={className} aria-hidden="true">
            <g fill="none" stroke={INK} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="30" y="30" width="100" height="100" rx="8" fill={PAPER}/>
                <rect x="36" y="36" width="88" height="88" rx="5" fill="none" stroke={INK_FAINT} strokeWidth="1"/>
                <circle cx="80" cy="80" r="18" fill={GOLD_SOFT}/>
                <path d="M72 80 L78 86 L90 74" stroke={INK} strokeWidth="1.5" fill="none"/>
            </g>
        </svg>
    );
}

// Small ✦ glyph used as a section / wordmark ornament.
export function Asterisk({className = 'inline-block'}) {
    return <span className={className} aria-hidden="true">✦</span>;
}

// Voice card inner circle avatar with a play/pause glyph.
export function VoiceAvatar({voiceId, active, playing}) {
    // Active = this voice is the currently selected narrator.
    // Playing = this voice's sample is the one currently being previewed.
    const bg = active ? '#FFFFFF' : '#F6F6F6';
    return (
        <div
            className={`w-7 h-7 rounded-full border-[1.5px] border-[#0E0E0E] flex items-center justify-center text-[11px] ${playing ? 'animate-pulse' : ''}`}
            style={{background: bg}}
            aria-hidden="true">
            {playing ? '⏸' : '▶'}
        </div>
    );
}
